import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../../api/request';
import { createFetchContext } from '../../../../../components/contexts/FetchContextFactory';
import { PeriodsLoaderQuery, PeriodsResponseType } from '../../types';
import { getPeriods } from '../../api';
import DisplayError from '../../../../../components/info/DisplayError';

export interface PeriodsLoaderProps {
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  PeriodsLoaderQuery,
  PeriodsResponseType,
  AxiosResultDefaultError
>();

export const usePeriods = useFetch;

export const PeriodsLoaderConsumer = FetchConsumer;

export function PeriodsLoader({ children }: PeriodsLoaderProps) {
  const request = useCallback(() => {
    return getPeriods();
  }, []);

  return (
    <FetchProvider request={request} defaultQuery={{}} fetchImmediately={true}>
      <FetchConsumer>
        {({ loading, error, refresh }) => {
          if (error) {
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }
          return children;
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
